import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { InputProps } from './types';

export default function CountyInput({ country, options, value, onChange }: InputProps) {
  if (!country.hasCounty || options.county?.show === false) {
    return null;
  }

  return (
    <ManagedFormGroup
      hasError={options.county?.hasError}
      label={options.county?.label || 'County'}
      required={options.county?.required}
      value={value.county}
      onValueChange={county => onChange({ ...value, county })}
    />
  );
}
